<template>
  <settings-modal
    class="banner-delete-modal t-banner-delete-modal"
  >
    <span
      slot="heading"
      class="font-weight-bold"
    >Delete "{{ banner.en.title }}" banner</span>

    <template slot="actions">
      <v-btn
        class="t-confirm-button"
        color="error"
        medium
        flat
        :disabled="loading"
        @click="onDeleteButtonClick"
      >delete banner</v-btn>

      <v-btn
        class="t-cancel-button"
        color="primary"
        medium
        flat
        @click="onCloseButtonClick"
      >cancel</v-btn>
    </template>
  </settings-modal>
</template>

<script>
  // Events
  import { EVENT_BANNER_CHANGE } from '@/events/banners'

  // Services
  import ApiRequest from '@/services/ApiRequests/ApiRequest'
  import BannerApi from '@/services/Api/BannerApi'

  // Mixins
  import modal from '@/mixins/modal'
  import flashMessages from '@/mixins/flashMessages'

  // Components
  import SettingsModal from '@/components/modals/SettingsModal'

  export default {
    name: 'BannerDeleteModal',
    components: {
      SettingsModal
    },
    mixins: [modal, flashMessages],
    data () {
      return {
        deleteBannerApiRequest: new ApiRequest(BannerApi.delete)
      }
    },
    computed: {
      banner () {
        return this.modalData.banner
      },
      loading () {
        return this.deleteBannerApiRequest.loading
      }
    },
    methods: {
      onDeleteButtonClick () {
        this.deleteBannerApiRequest.execute(this.banner.id)
          .then(() => {
            this.$eventHub.$emit(EVENT_BANNER_CHANGE)

            this.showSuccessFlashMessage('Banner has been successfully deleted.')
          })
          .catch(() => {
            this.showErrorFlashMessage('Banner has not been deleted.')
          })
      },
      onCloseButtonClick () {
        this.closeModal()
      }
    }
  }
</script>
